'use client';

import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import EventListing from './event-listing';
import SeriesGroupCard from './series-group-card';
import { groupRecentSeriesEvents, isSeriesGroup } from '../utils/group-recent-series-events';
import type { Event } from '../types/Event/Event';

const useStyles = makeStyles()((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  listItem: {
    padding: 0,
  },
}));

type Props = {
  events?: Event[];
  emptyMessage?: string;
};

const RecentEventList = ({ events, emptyMessage = 'No recently added events' }: Props) => {
  const { classes } = useStyles();

  if (!events || !events.length) {
    return <p>{emptyMessage}</p>;
  }

  const items = groupRecentSeriesEvents(events);

  return (
    <Paper className={classes.paper}>
      <ul className={classes.list}>
        {items.map((item, index) => {
          if (isSeriesGroup(item)) {
            return (
              <li className={classes.listItem} key={`series-${item.seriesId}`}>
                {index > 0 && <Divider sx={{ my: 2 }} />}
                <SeriesGroupCard group={item} />
              </li>
            );
          }
          return (
            <li className={classes.listItem} key={item.id}>
              {index > 0 && <Divider sx={{ my: 2 }} />}
              <EventListing event={item} fullDate />
            </li>
          );
        })}
      </ul>
    </Paper>
  );
};

export default RecentEventList;
